
import { useStore } from 'vuex';
import { computed } from '@vue/runtime-core';
import { Getters, Package } from '@/store/modules/PackageModule';
export default {
  components: {},
  props: {
    modelValue: {
      type: Array,
      default: () => [] as any[],
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const selectedId = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    const stores = computed<Package[]>(() => store.getters[Getters.PACKAGES]);

    return {
      selectedItems: computed(() =>
        stores.value.filter((s: Package) => selectedId.value.includes(s.id))
      ),
      remove(id: string) {
        const idx = selectedId.value.indexOf(id);

        if (idx > -1) {
          selectedId.value.splice(idx, 1);
        }
      },
    };
  },
};
